export default {"src":"/_next/static/media/white-flower.09de6442.svg","height":95,"width":100,"blurWidth":0,"blurHeight":0};